import React, { useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EnquiryDrawerForm = () => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const toggleDrawer = () => setOpen((prev) => !prev);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.name.trim()) formErrors.name = "Name is required";
    if (!formData.email.trim()) {
      formErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      formErrors.email = "Please enter a valid email address";
    }

    if (!formData.phone.trim()) {
      formErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(formData.phone)) {
      formErrors.phone = "Phone number must be exactly 10 digits";
    }

    if (!formData.message.trim()) formErrors.message = "Message is required";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return; // stop submission if validation fails
    }

    setLoading(true);
    try {
      const response = await fetch("https://100billionrealestate.com/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
        toast.success("Message sent successfully!");
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      {/* Enquiry Button */}
      <button
        className={`enquiry-form-drawer-name-v9-button ${open ? "open" : ""}`}
        onClick={toggleDrawer}
      >
        {open ? "Close" : "Enquiry"}
      </button>


      {/* Drawer Form */}
      <div className={`enquiry-form-drawer-name-v9 ${open ? "open" : ""}`}>
        <form className="enquiry-form-drawer-name-v9-form" onSubmit={handleSubmit}>
          <h4>Quick Enquiry</h4>

          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          {errors.name && <span className="error">{errors.name}</span>}

          {/* Email */}
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          {errors.email && <span className="error">{errors.email}</span>}

          {/* Phone Number */}
          <input
            type="text"
            name="phone"
            placeholder="Your Phone Number"
            value={formData.phone}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/\D/g, ""); // remove non-digits
              if (cleaned.length <= 10) {
                setFormData((prev) => ({ ...prev, phone: cleaned }));
              }
            }}

            required
          />
          {errors.phone && <span className="error">{errors.phone}</span>}

          {/* Message */}
          <textarea
            name="message"
            placeholder="Your Message"
            rows="3"
            value={formData.message}
            onChange={handleInputChange}
            required
          />
          {errors.message && <span className="error">{errors.message}</span>}

          {/* Submit Button */}
          <button type="submit" disabled={loading}>

            {loading ? "Submitting..." : submitted ? <span className="loader"></span> : "Submit"}

          </button>
        </form>
      </div>
    </>
  );
};

export default EnquiryDrawerForm;
